import { Badge } from "@transfr-inc/dashboard-components";

import "./demo.badge.scss";

export const DemoBadge = () => {
  return <Badge className="demo-badge" value="DEMO"></Badge>;
};
